import { render, staticRenderFns } from "./BrandingSwitchWarningModal.vue?vue&type=template&id=063b3f60&scoped=true"
import script from "./BrandingSwitchWarningModal.vue?vue&type=script&lang=js"
export * from "./BrandingSwitchWarningModal.vue?vue&type=script&lang=js"
import style0 from "./BrandingSwitchWarningModal.vue?vue&type=style&index=0&id=063b3f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b3f60",
  null
  
)

export default component.exports